import { render, staticRenderFns } from "./Scheme.vue?vue&type=template&id=4de80561&scoped=true"
import script from "./Scheme.vue?vue&type=script&lang=js"
export * from "./Scheme.vue?vue&type=script&lang=js"
import style0 from "./Scheme.vue?vue&type=style&index=0&id=4de80561&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de80561",
  null
  
)

export default component.exports